(function () {
    angular.module('shared').config(["$provide", function ($provide) {
            $provide.decorator('$http', ["$delegate", "$q", function ($delegate, $q) {
                    var postFn = $delegate.post, cancelerMap = {};
                    function getCancelerKey(url, data) {
                        data = _.clone(data);
                        if (!data)
                            data = {};
                        delete data.Login;
                        delete data.Password;
                        var obj = {
                            url: url,
                            data: data
                        };
                        return JSON.stringify(obj);
                    }
                    $delegate.post = function (url, data, _config) {
                        var cancelerKey, canceler;
                        var args = [].slice.call(arguments);
                        var config = _config || {};
                        if (config.timeout == null) {
                            cancelerKey = getCancelerKey(url, data);
                            canceler = $q.defer();
                            cancelerMap[cancelerKey] = canceler;
                            config.timeout = canceler.promise;
                            args[2] = config;
                        }
                        return postFn.apply(null, args);
                    };
                    $delegate.abort = function (request) {
                        var cancelerKey, canceler;
                        cancelerKey = getCancelerKey(request.url, request.data);
                        canceler = cancelerMap[cancelerKey];
                        if (canceler != null) {
                            if (request.timeout != null && typeof request.timeout !== "number") {
                                canceler.promise.status = "CANCEL";
                                canceler.resolve();
                                delete cancelerMap[cancelerKey];
                            }
                        }
                    };
                    return $delegate;
                }]);
        }]);


    // Custom XHR
    angular.module('shared').factory('$xhrFactory', function () {
        return function createXhr(method, url) {
            let aborted = false;
            let postData = null;
            let xhr = new window.XMLHttpRequest();
            let xhrError = new Error('[Request] error: '+ url);

            // Request is stuck on iOS (iOS will fire timeout if request is more than 5 minutes)
            xhr.addEventListener('timeout', (event) => {
                console.log('The request timed out.' + url);
                xhr.onerror(event);
            });

            // Log for crash
            xhr.addEventListener('readystatechange', (event) => {
                if (xhr.readyState === 4) {
                    if (xhr.status === 200) { // Load complete
                        var re = /(?:\.([^.]+))?$/;
                        var ext = re.exec(url)[1];   // "txt"
                        let excludes = ['html', 'json', 'svg']
                        if (ext && !excludes.find((currentExt) => {
                            return ext.indexOf(currentExt) === 0;
                        })) {
                            console.log('[Response] success:', url);
                        }
                    } else {
                        if (aborted) {
                            // Request is Abort
                            console.log('Abort request: ' + url);
                        } else {
                            // Request is error
                            let requestData = null;
                            if (postData) {
                                try {
                                    // ignore FormData (Upload file)
                                    if (!(postData instanceof window.FormData)) {
                                        requestData = JSON.parse(postData);
                                    }
                                } catch (e) {
                                }
                            }
                            // NF-834: Don't log password
                            if (requestData && (url.toLowerCase().indexOf('cordova/logon') !== -1||url.toLowerCase().indexOf('mobile/logon') !== -1)) {
                                if(requestData.Password) {
                                    requestData.Password = '*'.repeatString(requestData.Password.length);
                                }
                            }
                            // get response from responseText
                            let response  = null;
                            if(xhr.responseText){
                                try{ // parse responseText to json
                                    response = JSON.parse(xhr.responseText);
                                } catch(e) {
                                    response = xhr.responseText;
                                }
                            }
                            let data = {
                                url: url,
                                method: method,
                                requestData: requestData,
                                headers: xhr.getAllResponseHeaders(),
                                response: response,
                                status: xhr.status,
                                statusText: xhr.statusText
                            }
                            try {
                                xhrError.message = '[Response] error: ' +  JSON.stringify(data);
                                console.error(xhrError);
                            } catch (e) {
                                console.error(data);
                            }
                        }
                    }
                }
            });

            // Save postData to show error
            let send = xhr.send;
            xhr.send = function (data) {
                postData = data;
                send.apply(xhr, arguments);
            };

            // Turn on
            let abort = xhr.abort;
            xhr.abort = function () {
                aborted = true;
                abort.apply(xhr, arguments);
            }

            return xhr;
        };
    });
}());
